<template>
  <div :class="!$route.query.embed ? 'pb-12' : ''">
    <v-row v-if="!showSeatMap" no-gutters>
      <v-col
        :order="$vuetify.breakpoint.mdAndUp ? '0' : '1'"
        :cols="$vuetify.breakpoint.mdAndUp && !$route.query.embed ? '8' : '12'"
      >
        <MultiplePresentationsCarousel
          v-if="
            filteredPresentations?.length && !$route.query.listar_apresentacoes
          "
          :filteredPresentations="filteredPresentations"
        />

        <Message v-if="finishedQueue && !$route.query.listar_apresentacoes" />
        <ContainerProductsAndSectors
          v-if="
            productsDetails &&
            (!$route.query.listar_apresentacoes ||
              !filteredPresentations?.length)
          "
        />
        <MultiplePresentationsList
          v-else-if="
            filteredPresentations?.length && $route.query.listar_apresentacoes
          "
          :filteredPresentations="filteredPresentations"
        />
        <v-row v-else class="py-16" no-gutters justify="center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="60"
          ></v-progress-circular>
        </v-row>
      </v-col>
      <v-col
        v-if="
          $route.query.sectorMode
            ? cartProducts && cartProducts.length && $vuetify.breakpoint.mdAndUp
            : !$route.query.embed
        "
        :style="$vuetify.breakpoint.mdAndUp ? '' : 'background-color: #eee'"
        :order="$vuetify.breakpoint.mdAndUp ? '1' : '0'"
        :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
      >
        <Summary
          style="position: sticky; top: 65px"
          @createOrder="createOrder"
          :loading="loading"
        />
      </v-col>
    </v-row>
    <v-row v-else no-gutters>
      <Sector />
    </v-row>

    <FooterAction
      v-if="
        cartProducts &&
        cartProducts.length &&
        (!$vuetify.breakpoint.mdAndUp || showSeatMap) &&
        !$route.query.embed &&
        !this.$route.query.sectorMode
      "
      @createOrder="createOrder"
      :loading="loading"
      :cartProducts="cartProducts"
      :showSeatMap="showSeatMap"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ContainerProductsAndSectors from "../components/cart/Index.vue";
import FooterAction from "../components/cart/FooterAction.vue";
import Summary from "../components/summary/Index.vue";
import Sector from "../components/cart/sector/Index.vue";
import Message from "../components/queue/Message.vue";
import MultiplePresentationsCarousel from "../components/cart/multiplePresentations/Carousel.vue";
import MultiplePresentationsList from "../components/cart/multiplePresentations/List.vue";
import { bootstrap, setOptions } from "vue-gtag";

export default {
  components: {
    ContainerProductsAndSectors,
    FooterAction,
    Summary,
    Sector,
    Message,
    MultiplePresentationsCarousel,
    MultiplePresentationsList,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      "cartProducts",
      "productsDetails",
      "noSectorList",
      "showSeatMap",
      "finishedQueue",
      "lastOrderAndCart",
      "orderDetails",
      "productsTotal",
      "totalWithoutTax",
      "eventDetails",
      "pdv",
      "loginPosData",
      "selectedSector",
      "storeDetails",
      "eventId",
      "widgetMode",
    ]),
    tiktokPixel() {
      return this.findTokenPerType("tiktok");
    },
    googleAds() {
      return this.findTokenPerType("google_ads");
    },
    facebookPixel() {
      return this.findTokenPerType("facebook_pixel");
    },
    googleAnalytics() {
      return this.findTokenPerType("google_analytics");
    },

    filteredPresentations() {
      if (
        this.eventDetails &&
        this.eventDetails.relacionados &&
        this.eventDetails.relacionados.length
      ) {
        let filteredPresentations = this.eventDetails.relacionados.filter(
          (presentation) => {
            let endDate = this.$moment.unix(presentation.data_encerramento_ts);

            let today = this.$moment();

            return !endDate.isBefore(today);
          }
        );

        return filteredPresentations;
      }

      return [];
    },
  },

  mounted() {
    this.startGA();
    this.listenSite();
  },

  methods: {
    async createOrder() {
      if (
        this.lastOrderAndCart &&
        this.lastOrderAndCart.cart === JSON.stringify(this.noSectorList) &&
        this.lastOrderAndCart.selectedSector ===
          JSON.stringify(this.selectedSector)
      ) {
        this.$store.commit(
          "SET_ORDER_DETAILS",
          JSON.parse(this.lastOrderAndCart.order)
        );

        let nextRouteName =
          this.eventDetails.one_checkout === 40 ||
          this.eventDetails.one_checkout === 42 ||
          this.eventDetails.checkout_nomeacao_obrigatoria == 2
            ? "Payment"
            : "Participants";

        await this.$router.push({
          name: this.lastOrderAndCart.route || nextRouteName,
          params: { event: this.eventId },
          query: this.$route.query,
        });
        this.setStorage(this.lastOrderAndCart.route);
      } else {
        this.loading = true;
        this.$store.commit("SET_ERROR_MESSAGE_CARD", "");
        await this.$store
          .dispatch("createOrder", this.cartProducts)
          .then((resp) => {
            if (this.$route.query.embed || this.$route.query.sectorMode)
              localStorage.removeItem(
                `wait-authentication-${this.eventDetails.codigo}`
              );
            if (resp.status === 200 && resp.data && !resp.data.error) {
              this.gAnalytics();
              this.addFacebookPixel();
              this.addGoogleAds();
              if (this.tiktokPixel) this.addTiktoPixel();
              this.setNextRoute();
            } else {
              if (
                (this.$route.query.embed || this.$route.query.sectorMode) &&
                resp?.data?.error
              ) {
                window.parent.postMessage(
                  {
                    error: resp?.data?.error,
                  },
                  "*"
                );
              } else {
                this.$store.dispatch("openSnackbar", {
                  message: resp.data.error,
                  color: "error",
                });
              }
            }
            this.loading = false;
          })
          .catch((e) => {
            if (e) this.loading = false;

            if (
              (this.$route.query.embed || this.$route.query.sectorMode) &&
              e?.response?.data?.message
            ) {
              window.parent.postMessage(
                {
                  error: e?.response?.data?.message,
                },
                "*"
              );
            }
          });
        this.loading = false;
      }
    },
    setStorage(route) {
      let obj = {
        order: this.orderDetails,
        cart: this.noSectorList,
        productsDetails: this.productsDetails,
        selectedSector: this.selectedSector,
        route: route ? route : "Participants",
      };
      localStorage.setItem(
        `cart-order-route-${this.eventId}`,
        JSON.stringify(obj)
      );
    },

    startGA() {
      if (this.googleAnalytics) {
        let options = {};

        options = {
          config: {
            id: `${
              this.isLetter(String(this.googleAnalytics).charAt(0)) ? "" : "UA-"
            }${this.googleAnalytics}`,
          },
        };
        setOptions(options);

        bootstrap();
      }
    },

    gAnalytics() {
      if (this.googleAnalytics) {
        let products = [];
        this.cartProducts.forEach((item) => {
          item.forEach((p) => {
            let product = {
              id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
              name: `${this.eventDetails.nome} - ${p.nome}`,
              sku: String(p.codigo_produto),
              category: "Evento",
              price: p.valor,
              quantity: p.quantidade,
            };
            products.push(product);
          });
        });

        this.$gtag.query("event", "add_to_cart", {
          value: this.productsTotal,
          currency: "BRL",
          items: products,
        });
      }
    },
    async addFacebookPixel() {
      let metaPixelStore = this.storeDetails?.configs?.metaPixel;

      if (this.facebookPixel) {
        const facebookIntegrations =
          this.eventDetails?.integracoes_publicas.filter(
            (integration) => integration.tipo === "facebook_pixel"
          );

        facebookIntegrations.forEach((integration) => {
          var addToCart = document.createElement("img");
          addToCart.src = `https://www.facebook.com/tr?id=${integration.credenciais.token}&ev=AddToCart&eid=${this.orderDetails.codigo_evento}-${this.orderDetails.codigo_pedido}&cd[currency]=BRL&cd[value]=${this.totalWithoutTax}&cd[content_type]=product`;

          addToCart.src += `&cd[contents][0][id]=${`${this.orderDetails.codigo_evento}-${this.orderDetails.codigo_pedido}`}&cd[contents][0][quantity]=1`;

          addToCart.src = this.incrementStringInSrc(addToCart.src);

          addToCart.style = "display:none;";
          addToCart.height = 1;
          addToCart.width = 1;
          document.getElementsByTagName("head")[0].appendChild(addToCart);
        });
      }

      if (metaPixelStore) {
        var addToCartStore = document.createElement("img");
        addToCartStore.src = `https://www.facebook.com/tr?id=${metaPixelStore}&ev=AddToCart&eid=${this.orderDetails.codigo_evento}-${this.orderDetails.codigo_pedido}&cd[currency]=BRL&cd[value]=${this.totalWithoutTax}&cd[content_type]=product`;

        addToCartStore.src += `&cd[contents][0][id]=${`${this.orderDetails.codigo_evento}-${this.orderDetails.codigo_pedido}`}&cd[contents][0][quantity]=1`;

        addToCartStore.src = await this.incrementStringInSrc(
          addToCartStore.src
        );

        addToCartStore.style = "display:none;";
        addToCartStore.height = 1;
        addToCartStore.width = 1;
        document.getElementsByTagName("head")[0].appendChild(addToCartStore);
      }
    },

    incrementStringInSrc(src) {
      let newSrc = src;

      this.cartProducts.forEach((products) => {
        products.forEach((product, index) => {
          newSrc += `&cd[contents][${index + 1}][id]=${
            product.codigo_produto
          }&cd[contents][${index + 1}][quantity]=${product.quantidade}`;
        });
      });

      return newSrc;
    },

    addGoogleAds() {
      const cartToken = this.findCartTokenPerType("google_ads");

      if (cartToken && this.googleAds) {
        this.$gtag.event("conversion", {
          send_to: cartToken.startsWith("AW")
            ? cartToken
            : `${this.googleAds}/${cartToken}`,
          transaction_id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
          event_category: "Carrinho",
          event_label: "Total",
          currency: "BRL",
          value: String(this.productsTotal),
          event_value: String(this.productsTotal),
        });

        this.$gtag.event("conversion", {
          send_to: this.storeDetails?.configs?.googleAnalytics,
          transaction_id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
          event_category: "Carrinho",
          event_label: "Total",
          currency: "BRL",
          value: String(this.productsTotal),
          event_value: String(this.productsTotal),
        });
      }
    },

    addTiktoPixel() {
      window.ttq.track("AddToCart", {
        product_group: "product_group",
        content_id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
        content_category: "ecommerce",
        value: this.productsTotal,
        description: "Total",
        currency: "BRL",
      });
    },
    isLetter(str) {
      return /[a-zA-Z]/.test(str);
    },
    setNextRoute() {
      let nextRouteName =
        this.eventDetails.one_checkout === 40 ||
        this.eventDetails.one_checkout === 42 ||
        this.eventDetails.checkout_nomeacao_obrigatoria == 2 ||
        (this.eventDetails.checkout_nomeacao_obrigatoria == 0 &&
          !this.$moment(
            this.eventDetails.data_nomeacao_ingresso,
            "YYYY-MM-DD HH:mm:ss"
          ).isBefore())
          ? "Payment"
          : "Participants";

      if (this.orderDetails) {
        const hasExtraData = this.orderDetails.ingressos.find(
          (i) => i.dados_extras.length
        );
        if (!hasExtraData) {
          nextRouteName = "Payment";
        }
      }

      this.goNextStep(nextRouteName);
      this.setStorage(nextRouteName);
    },
    goNextStep(route) {
      if (this.$route.query.embed || this.$route.query.sectorMode) {
        window.parent.postMessage(
          {
            route: route.toLowerCase(),
          },
          "*"
        );
      } else {
        // if (this.widgetMode) {
        //   this.$store.commit("SET_STEP", route);
        // } else {
        this.$router.push({
          name: route,
          params: { event: this.eventId },
          query: this.$route.query,
        });
        // }
      }
    },
    findTokenPerType(type) {
      return this.eventDetails?.integracoes_publicas?.find(
        (i) => i.tipo === type
      )?.credenciais?.token;
    },

    findCartTokenPerType(type) {
      return this.eventDetails?.integracoes_publicas?.find(
        (i) => i.tipo === type
      )?.credenciais?.add_to_cart;
    },

    listenSite() {
      window.addEventListener("message", async (event) => {
        if (event.data === "create-order") {
          try {
            await this.createOrder();
          } catch (e) {
            console.log(e);
          }
        }
      });
    },
  },
};
</script>
